import { captureException } from '@sentry/browser';
import packageInfo from '../package.json.js';
import { ENV } from '../environment.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
const captureErrorInSentry = (error, scopeContext) => {
    ENV.isDev && console.log('Sentry capture', { error, scopeContext });
    const { tags, ...context } = scopeContext;
    captureException(error, {
        ...context,
        // Prevent different errors from being merged in Sentry
        fingerprint: ['{{default}}', String(error?.message)],
        tags: {
            ...tags,
            application: 'samples-component',
            path: window.location.pathname,
        },
    });
};
const logError = (error, action) => {
    ENV.isDev && action && console.error(`Failed to ${action} - `, error);
    ENV.isDev && !action && console.error(error);
    captureErrorInSentry(error, {
        contexts: action ? { action: { name: action } } : {},
        tags: { version: packageInfo.version },
    });
};

export { logError };
//# sourceMappingURL=error-service.js.map
